import "./App.css";
import Rooms from "./Components/Rooms/Rooms";
import Contact from "./Components/Contact/Contact";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import BlogDetails from "./Components/Pages/BlogDetails";
import BookingForm from "./Components/BookingForm";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Gallery from "./Components/Gallery/Gallery";
import Location from "./Components/Location/Location";
import StandardRoomDetails from "./Components/Pages/StandardRoomDetails";
import DeluxeRoomDetail from "./Components/Pages/DeluxeRoomDetail";
import PremiumRoomDetail from "./Components/Pages/PremiumRoomDetail";
import Aminities from "./Components/Aminities/Aminities";
import Policies from "./Components/Policies/Policies";
import './i18n'
import Feedback from "./Components/Feedback";
import Slider from "./Components/Slider";
import Blog from "./Components/Blog";
import { ToastContainer } from "react-toastify";
import BlogDetail from "./Components/BlogDetail";

AOS.init();
function App() {
  return (
    <div>
      <Router>
        <ToastContainer/>
      <Header />
        <Routes>
          <Route path="/" element={<Slider/>} />
          <Route path="/book-now/*" element={<Rooms />} />
          <Route path="/location" element={<Location/>}/>
          <Route path="/gallery" element={<Gallery/>}/>
          <Route path="/standard-room-details" element={<StandardRoomDetails />} />
          <Route path="/deluxe-room-details" element={<DeluxeRoomDetail />} />
          <Route path="/premium-room-details" element={<PremiumRoomDetail />} />
          <Route path="/our-rooms/*" element={<Aminities/>}/>
          <Route path="/policies" element={<Policies/>}/>
          <Route path="/blog-details" element={<BlogDetails/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<BookingForm />} />
          <Route path="/blog" element={<Blog/>}/>
          <Route path="/blog-detail/:id" element={<BlogDetail/>}/>
          <Route path="/feedback" element={<Feedback/>}/>
        </Routes>
      {/* <Footer /> */}
      </Router>
    </div>
  );
}

export default App;
